/*
 * These are the values that define the Kiddom tree types
 * */

export type AssignmentType =
  | 'paper'
  | 'quiz'
  | 'homework'
  | 'video'
  | 'participation'
  | 'exit_ticket'
  | 'pre_test'
  | 'test'
  | 'midterm'
  | 'final'
  | 'state_national_assessment'
  | 'project'
  | 'presentation'

export type GradingType = 'formative' | 'summative'

export type DurationUnit = 'minutes' | 'hours' | 'days' | 'weeks'

export enum NodeType {
  Course = 'course',
  NodeList = 'node_list',
  SkillsList = 'skills_list',
  /**
   * Use SkillList instead. WeightedSkillsList is deprecated as a trace of an old project
   * is still used on old curriculas, be aware before deleting
   * @deprecated in favor of {@link SkillsList}
   * */
  WeightedSkillsList = 'weighted_skills_list',
  Note = 'note',
  Document = 'document',
  Question = 'question',
  MultiPartQuestion = 'multipart_question',
  Inline = 'inline_node',
  Assessment = 'assessment',
  Activity = 'activity',
  AttachmentsList = 'attachments_list',
  QuestionAnswer = 'question:answer',
  LessonPlan = 'lesson_plan',
  Unit = 'unit',
  InstructionalBlock = 'instructional_block',
  Module = 'module',
  Presentation = 'presentation',
  EmbeddedContent = 'embedded_content',
  QuestionTarget = 'question:target',
  QuestionItem = 'question:item',
  QuestionPlaceholder = 'question:placeholder',
  QuestionPlaceholderDnD = 'question:placeholder_with_drag_and_drop',
  Notebook = 'notebook',
  MissingType = '',
  ReferenceSkillsList = 'reference:skills_list',
  ReferenceLessonPlan = 'reference:lesson_plan',
  ReferenceActivity = 'reference:activity',
  ReferenceAssessment = 'reference:assessment',
}

export const ReferenceNodeTypes = [
  NodeType.ReferenceSkillsList,
  NodeType.ReferenceLessonPlan,
  NodeType.ReferenceActivity,
  NodeType.ReferenceAssessment,
]

export enum QuestionType {
  ShortResponse = 'short_response',
  MultipleChoice = 'multiple_choice',
  MultipleSelect = 'multiple_select',
  Classifying = 'classifying',
  StudentClassifying = 'student_classifying',
  Drawing = 'drawing',
  Matching = 'matching',
  Ordering = 'ordering',
  Placeholder = 'placeholder',
  PlaceholderDnD = 'placeholder_with_drag_and_drop',
  PrefilledAnswer = 'prefilled_answer',
  Audio = 'audio',
  Video = 'video',
  Upload = 'upload',
  ShortAnswer = 'short_answer',
  Graphing = 'graphing',
}

export enum NodeBodyKeys {
  Assignable = 'isAssignable',
  StudentFacing = 'studentFacing',
  Correct = 'correct',
  Type = 'type',
  Value = 'value',
  ExternalID = 'ExternalID',
  Answer = 'answer',
  ShowWork = 'showWork',
}

export enum LeafTypes {
  Attribution = 'attribution',
  AssessmentGrading = 'assessment_grading',
  Assignment = 'assignment',
  Points = 'points',
  Duration = 'duration',
  Question = 'question',
  Attachment = 'attachment',
  AppletGeogebra = 'applet:geogebra',
  Grade = 'grade',
  Subject = 'subject',
  GoogleContent = 'content:google',
  AnswerEditor = 'answer:editor',
  Skill = 'skill',
  /**
   * Use Skill instead. WeightedSkill is deprecated as a trace of an old project
   * is still used on old curriculas, be aware before deleting
   * @deprecated in favor of {@link Skill}
   * */
  WeightedSkill = 'weighted_skill',
}

export enum LeafBodyValues {
  Type = 'type',
  SubjectID = 'subjectID',
  GradeID = 'gradeID',
  ID = 'id',
  Name = 'name',
  MimeType = 'mimeType',
  URL = 'url',
  IsIngested = 'is_ingested',
}

export const AssignableNodeTypes = [
  NodeType.Activity,
  NodeType.Assessment,
  NodeType.Presentation,
  NodeType.LessonPlan,
  NodeType.Notebook,
]

export const NavigableNodeTypes = [
  NodeType.Course,
  NodeType.Unit,
  NodeType.Module,
  NodeType.InstructionalBlock,
  NodeType.Document,
  ...AssignableNodeTypes,
]

export interface AwsContentItem {
  key: string
  URL: string
  last_modified: string
}

export interface AwsListResult {
  contents: AwsContentItem[]
}
